(function() {
	'use strict';
	angular.module('gatewayApp').factory('NotificationSettings', NotificationSettings);

	NotificationSettings.$inject = [ '$resource' ];

	function NotificationSettings($resource) {
		var resourceUrl = 'api/bankSpecificSettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				 params: {bankId: '@bankId'},
				url : 'api/get-bank-specific-settings',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'updateNotificationSettings' : {
				method : 'POST',
				params:{notificationSettings:'notificationSettings'},
				url : 'api/bank-notification-settings',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			'resubmitForEdit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmit/notificationSettings',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			}
		});
	}
})();
